import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { isSameDay, isToday } from '../utils/dates';

/**
 * passa para dd/MM/yyyy HH'h'mm , se passar 'hideTime' caso hora seja só 0000, coloca ---
 * @param hideTimeIfZeros Passar 'hideTime' se precisar da função de ---
 */
@Pipe({
  name: 'isSameDayPipe'
})
export class IsSameDatePipe implements PipeTransform {


  transform(value: Date, other: Date)  {
    return isSameDay(value , other)
  }

}

@Pipe({
  name: 'isToday'
})
export class IsTodayPipe implements PipeTransform {


  transform(value?: Date | undefined | null)  {
    return isToday(value )
  }

}
